import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const TrashGlyph = /*#__PURE__*/createElement("g", {
  id: "trash"
}, /*#__PURE__*/createElement("path", {
  d: "M57.48,20.09H52.32V17.82A3.32,3.32,0,0,0,49,14.5H35a3.32,3.32,0,0,0-3.32,3.32v2.27H26.52A5,5,0,0,0,21.57,25v5.16a1.5,1.5,0,0,0,1.5,1.5h2.48v33.6A4.69,4.69,0,0,0,30.24,70H54a4.69,4.69,0,0,0,4.68-4.69V31.69h2.27a1.5,1.5,0,0,0,1.5-1.5V25A5,5,0,0,0,57.48,20.09Zm-22.8-2.27A.32.32,0,0,1,35,17.5H49a.32.32,0,0,1,.32.32v2.27H34.68ZM28.55,65.29V31.69h6.9V67H30.24A1.69,1.69,0,0,1,28.55,65.29Zm17.22-33.6V67H38.45V31.69Zm9.89,33.6A1.69,1.69,0,0,1,54,67H48.77V31.69h6.89Zm3.77-36.6H24.57V25a1.94,1.94,0,0,1,1.95-1.94h31a2,2,0,0,1,2,1.94Z"
}));
const Trash = createSvg({
  name: 'trash',
  path: TrashGlyph
});

export default Trash;
export { TrashGlyph };
